import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { OnInit, OnDestroy } from '@angular/core';

export class CustomerFilterLanguage implements OnInit, OnDestroy {
    languageSub: Subscription;
    language = localStorage.getItem('__language') || 'vi';
    constructor(private translateService: TranslateService) {
        this.languageSub = this.translateService.onLangChange.subscribe(({ lang }) => {
            this.language = lang;
        });
    }
    ngOnInit() { }
    /**
     * check English Language
     */
    get isEnglish() {
        return this.language === 'en';
    }

    get isChinese() {
        return this.language === 'zh';
    }
    get isSpanish() {
        return this.language === 'es';
    }
    /**
     * Filter option by language
     */
    public filterOptionsData(options) {
        if (typeof options !== 'undefined') {
            console.log('All options:', options); // ← thêm dòng này
            console.log('Current lang:', this.language);
            
            const find = (lang) => {
              const opt = options !== '' ? options.find(opt => opt.language === lang) : '';
              console.log(`find('${lang}'):`, opt); // ← thêm dòng này
              return opt && opt.name || '';
            };
            if (this.isEnglish) { return find('en'); }
            if (this.isChinese) { return find('zh'); }
            if (this.isSpanish) { return find('es'); }
            return find('vi');
        }
    }

    ngOnDestroy() {
        this.languageSub.unsubscribe();
    }
}
